const measuringContext = document.createElement("canvas").getContext("2d");

/** Returns null where no 2d canvas context is available. */
export const measureTextWidth = ({
  text,
  font,
}: {
  text: string;
  font: string;
}): number | null => {
  if (measuringContext === null) {
    return null;
  }
  measuringContext.font = font;
  return measuringContext.measureText(text).width;
};
